import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { URL } from '../config/url';

// Volta sozinho para a página inicial, como o texto promete; sem login, o RequireAuth de lá leva ao login
const REDIRECT_DELAY = 3000;

function NotFound({ addInfo }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (addInfo) return;
    const timer = setTimeout(() => navigate(URL.index, { replace: true }), REDIRECT_DELAY);
    return () => clearTimeout(timer);
  }, [addInfo, navigate]);

  function Render() {
    return (
      <>
        <Row style={{ minHeight: '70vh' }} className="align-items-center">
          <Col className="text-center">
            <strong>
              <h3>
                <Spinner animation="grow" variant="danger" /> &nbsp; Página não encontrada! &nbsp;
                <Spinner animation="grow" variant="danger" />
              </h3>
            </strong>
            {!addInfo ? (
              <>
                <br />
                <Link to={URL.index} replace>Caso não seja redirecionado clique aqui!</Link>
              </>
            ) : (
              <></>
            )}
          </Col>
        </Row>
      </>
    );
  }

  return (
    <Container>
      {addInfo ? (
        <>
          <div className="mt-3 mb-4">
            <Row>
              <Col>
                <h5>{addInfo.title}</h5>
              </Col>
              <Col md="auto">
                <Link className="btn btn-outline-secondary" to={addInfo.urlGoBack}>
                  Voltar
                </Link>
              </Col>
            </Row>
          </div>

          {Render()}
        </>
      ) : (
        Render()
      )}
    </Container>
  );
}

export default NotFound;
